module.exports = __webpack_public_path__ + "img/microsoft.f32b3f89.svg";